module.exports = __webpack_public_path__ + "key.jpg?ecc324c036b15002adb9dc1cd4ccb3af";